import { logInTestEnv } from "./logger";

export function updateHeaderLogo(headerUrl: string | null| undefined, altText?: string,hamburgerViewLogoImageUrl?:string | null | undefined): void {

    //Null check on headerUrl
    if (!headerUrl) {
        console.log("Header URL not found");
        return;
    }

   // Validate the header URL
   if (!isValidImageUrl(headerUrl)) {
        return;
    }

    //Retrieve all existing logo DOM elements
    const existingHeaderLogo = document.querySelectorAll<HTMLImageElement>('header .brand-logo');
    const existingMobileHeaderLogo = document.querySelectorAll<HTMLImageElement>('.brand-logo-mobile img');
   //Replace all footer logo's image src and alt text
    const footerLogo = document.querySelectorAll<HTMLImageElement>('#footer .fb-des-col a picture img');
    if (existingHeaderLogo.length === 0 || existingMobileHeaderLogo.length === 0) {
        console.log("No brand logo elements found");
        return;
    }
    try {
        changeLogoPath(existingHeaderLogo, headerUrl, altText);
        changeLogoPath(existingMobileHeaderLogo, headerUrl, altText);
 
        const footerLogoSrcSet = document.querySelectorAll<HTMLImageElement>('#footer .fb-des-col a picture');

        //Replace the logo and alt text only when Footer Elements present in DOM
        if (footerLogo.length > 0) {
            const footerLogoUrl = hamburgerViewLogoImageUrl || headerUrl; // For footer logo, use the hamburger logo URL if backgorund is white
            changeLogoPath(footerLogo,footerLogoUrl, altText); 
            footerLogoSrcSet.forEach(picture => {
                // Select all <source> elements
                const sources = picture.querySelectorAll('source');
                sources.forEach(source => {
                    // Replace the srcset with the headerUrl
                    source.srcset = `${footerLogoUrl}`;
                });
            });
        }
        else {
            console.log("No footer logo elements found");
        }
        localStorage.setItem('localHeaderUrl', headerUrl);
        if(altText){
            localStorage.setItem('localHeaderAlt', altText);
        }

       
    } catch (error) {
        console.error("Error while updating header logo or saving to localStorage", error);
    }

    try {
        // Updating Find my Location Modal && Nearby Logo 
        changeWhiteBackgroundLogoPath(hamburgerViewLogoImageUrl?.trim() ? hamburgerViewLogoImageUrl?.trim() : headerUrl, altText);
    } catch (error) {
        logInTestEnv("Error while updating the ", error);
        
    }
}

//Actual function to change the logo
export function changeLogoPath(existingLogo: NodeListOf<HTMLImageElement>, headerUrl: string, altText?:string): void {
    existingLogo.forEach((logo: HTMLImageElement) => {
        try {
            logo.src = headerUrl;
            if(altText){
                logo.alt = altText;
            }
        } catch (error) {
            console.error("Error while updating logo src", error);
        }
    });
}

// This function is used to update the NBLY logo in the footer 

export function changeNBLYFooterLogoPath(
    existingLogos: NodeListOf<HTMLImageElement>,
    newUrl: string,
    altText?: string
): void {
    existingLogos?.forEach((logo: HTMLImageElement) => {
        try {
            // Update <img> tag
            if(newUrl){
                logo.src = newUrl;
                if (altText) {
                    logo.alt = altText;
                }

                // Update <source> elements within the same <picture> parent
                const picture = logo.closest('picture');
                if (picture) {
                    const sources = picture.querySelectorAll('source');
                    sources?.forEach((source) => {
                        source?.setAttribute('srcset', newUrl);
                    });
                }
            }
        } catch (error) {
            console.error("Error while updating logo paths", error);
        }
    });
}

export function updateHamburgerLogoImage(
    hamburgerViewLogoImageUrl: string | null | undefined,
    hamburgerLogo: HTMLElement | null,
    logoAltText: string = "Hamburger Menu Logo"
): void {
    try {
        // Validate the hamburger logo URL
        if (hamburgerViewLogoImageUrl) {
        
            if (!isValidImageUrl(hamburgerViewLogoImageUrl)) {
                return;
            }

            // Update the hamburger logo element
            if (hamburgerLogo) {
                hamburgerLogo.setAttribute("src", hamburgerViewLogoImageUrl);
                hamburgerLogo.setAttribute("alt", logoAltText);
                console.log("Hamburger logo updated successfully");
            }
        }
        
    } catch (error) {
        console.error("An unexpected error occurred while updating the hamburger logo:", error);
    }
}

export function isValidImageUrl(url: string | null | undefined): boolean {
    if (!url || url?.trim() === "") {
        console.error("Image URL is null, undefined, or empty");
        return false;
    }

    const validExtensions = new Set(['png', 'jpg', 'jpeg', 'gif', 'svg', 'webp']);
    const fileExtension = url.split('.').pop()?.toLowerCase();

    if (!fileExtension) {
        console.error(`No file extension found in URL: ${url}`);
        return false;
    }

    if (!validExtensions.has(fileExtension)) {
        console.error(`Invalid file extension for image URL: ${url}`);
        return false;
    }

    return true;
}

export function changeWhiteBackgroundLogoPath(hamburgerViewLogoImageUrl: string, altText?: string): void {
    //Updating the logo for white background using the hamburger logo URL, as there is no separate logo URL for the white background.
    try {
        if(hamburgerViewLogoImageUrl){

            // Validate the hamburger logo URL
            if (!isValidImageUrl(hamburgerViewLogoImageUrl)) {
                return;
            }

            // Updating logo Find my Localtion Modal && Nearby Logo
            const findByLocalAndNearByLocalModal = document.querySelectorAll<HTMLImageElement>('.modal-loc-inner .brand-logo');
            if (findByLocalAndNearByLocalModal?.length > 0) {
                changeLogoPath(findByLocalAndNearByLocalModal, hamburgerViewLogoImageUrl, altText);
            }

            // Updating logo for footer NBLY Logo
            const footerNBLYLogo = document.querySelectorAll<HTMLImageElement>('.neighborly-footer .ftr-nbly-logo picture img');
            if (footerNBLYLogo?.length > 0) {
                changeNBLYFooterLogoPath(footerNBLYLogo,hamburgerViewLogoImageUrl, altText);
            }

            //Update the hamburger logo if it exists
            const hamburgerLogo = document.querySelector<HTMLImageElement>('.main-nav-warpper .sidenav-brand-logo img');
            if (hamburgerLogo) {
                updateHamburgerLogoImage(hamburgerViewLogoImageUrl, hamburgerLogo, altText);
            }
        }

    } catch (error) {
        logInTestEnv("Error while updating logo src", error);
    }

}